import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import {
  loadThirdPartyCorrespondenceAsync,
  selectThirdPartyCorrespondence,
} from "../../../redux/slices/thirdPartyCorrespondence";
import ThirdPartyCorrespondenceHeader from "./ThirdPartyCorrespondenceHeader";
import ThirdPartyCorrespondenceDetails from "./ThirdPartyCorrespondenceDetails";
import Page500 from "../../../pages/auth/Page500";

const ThirdPartyCorrespondence = () => {
  const [loading, setLoading] = useState(false);
  const [
    loadingThirdPartyCorrespondenceId,
    setLoadingThirdPartyCorrespondenceId,
  ] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const thirdPartyCorrespondenceSelector = useAppSelector(
    selectThirdPartyCorrespondence
  );

  const dispatch = useAppDispatch();

  let { profileNo, thirdPartyCorrespondenceId } = useParams();
  if (!profileNo || !thirdPartyCorrespondenceId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingThirdPartyCorrespondenceId !== thirdPartyCorrespondenceId) {
    setLoadingThirdPartyCorrespondenceId(thirdPartyCorrespondenceId);
    dispatch(loadThirdPartyCorrespondenceAsync(thirdPartyCorrespondenceId));
    return <Loading />;
  }

  const thirdPartyCorrespondence =
    thirdPartyCorrespondenceSelector.thirdPartyCorrespondence;

  if (!thirdPartyCorrespondence) {
    return <Loading />;
  }

  if (!thirdPartyCorrespondence.response.ok) {
    if (thirdPartyCorrespondence.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ThirdPartyCorrespondenceHeader
            thirdPartyCorrespondence={thirdPartyCorrespondence}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ThirdPartyCorrespondenceDetails
            thirdPartyCorrespondence={thirdPartyCorrespondence}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            licenceProfile={licenceProfile}
            thirdPartyCorrespondence={thirdPartyCorrespondence}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        thirdPartyCorrespondence={thirdPartyCorrespondence}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default ThirdPartyCorrespondence;
